<template>
  <div class="user-form">
    <toolbar
      backRoute="/dashboard/"
      :beforeBack="checkForChanges"
      title="My profile"
      saveButtonLabel="Save changes"
      saveButtonEvent="my-account-save"
      :saveInProgress="saveInProgress" />

    <d-container fluid class="common-form px-0 pt-5 pb-5">
      <d-form>
        <validation-observer ref="my-account-form" tag="form" v-if="!loadError && allDataLoaded">
          <d-row>
            <d-col cols="6" class="ml-auto mr-auto">
              <div class="form-group">
                <label for="name">Name:</label>

                <validation-provider
                  rules="required"
                  name="name"
                  v-slot="{ errors }">
                  <d-input
                    v-model="data.name"
                    :state="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label for="email">E-mail:</label>

                <validation-provider
                  rules="email"
                  name="email"
                  v-slot="{ errors }">
                  <d-input
                    v-model="data.email"
                    :state="errors.length ? 'invalid' : null" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group d-flex mt-5">
                <d-button
                  outline
                  @click.prevent="$router.push('/dashboard/change-password')">
                  Change password
                </d-button>

                <d-button
                  v-if="!$store.getters.get2faStatus"
                  class="ml-auto"
                  theme="success"
                  outline
                  @click.prevent="$router.push('/dashboard/2fa/activate')">
                  Activate 2FA
                </d-button>

                <d-button
                  v-if="$store.getters.get2faStatus"
                  class="ml-auto"
                  theme="danger"
                  outline
                  @click.prevent="$router.push('/dashboard/2fa/deactivate')">
                  Deactivate 2FA
                </d-button>
              </div>
            </d-col>
          </d-row>
        </validation-observer>

        <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
          Loading data&hellip;
        </div>

        <d-alert
          v-if="loadError"
          show
          theme="warning">
          The app were unable to load data. <a href="javascript:window.location.reload();" class="alert-link">Refresh the app</a> to try again.
        </d-alert>
      </d-form>
    </d-container>
  </div>
</template>

<script>
import FormUtils from './../utils/FormUtils.js';
import HasChangesDetection from './../mixins/HasChangesDetection.vue';

export default {
  name: 'my-account-form',
  mixins: [
    HasChangesDetection
  ],
  computed: {
    allDataLoaded () {
      return this.loadedData;
    }
  },
  data () {
    return {
      data: {
        id: 0,
        name: '',
        email: ''
      },
      loadError: false,
      loadedData: false,
      saveInProgress: false
    };
  },
  mounted () {
    this.loadData();
    this.$bus.$on('my-account-save', this.validateForm);
  },
  methods: {
    loadData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/profile/item',
        id: null,
        instanceFields: ['id', 'name', 'email'],
        loadedKey: 'loadedData'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['my-account-form'], this.submitForm);
    },
    submitForm () {
      let endpointUrl = '/profile/update';

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: this.data,
        successTitle: 'Changes saved',
        successText: 'The changes have been successfully saved!',
        errorTitle: 'An error occurred!',
        errorText: 'The operation not finished successfully. Please try again.',
        successAction: () => {
          this.$router.push('/dashboard/');
          this.$root.loadProfile();
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('my-account-save', this.validateForm);
  }
}
</script>
